// API Configuration
const API_CONFIG = {
  // Production server - ALWAYS USE THIS
  PRODUCTION: 'https://api45.fbo.vn',
  
  // Local development server (for fallback only)
  LOCAL: 'http://localhost:3368',
  
  // Always return production URL
  get BASE_URL() {
    return this.PRODUCTION; // Always use production
  },
  // Disable manual override
  FORCE_PRODUCTION: true, // Always true
  FORCE_LOCAL: false, // Always false
  get CURRENT_URL() {
    return this.PRODUCTION; // Always return production
  },
  // Helper function to build complete API URLs
  getApiUrl: (endpoint) => {
    const baseUrl = API_CONFIG.CURRENT_URL;
    const cleanEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
    return `${baseUrl}${cleanEndpoint}`;
  }
};
export default API_CONFIG;
